import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Avatar,
    Box,
    Chip,
    Typography
} from '@mui/material';


const parseTimestamp = (timestamp) => {
    const now = Date.now();
    let ts = now
    if(!isNaN(Date.parse(timestamp['$date']))){
        ts = new Date(timestamp['$date'])
    }
    const differenceInMs = now - ts;
    const differenceInMinutes = Math.floor(differenceInMs / (1000 * 60));
    const differenceInHours = Math.floor(differenceInMs / (1000 * 60 * 60));
    if (differenceInMinutes < 1) {
        return "Just Now";
    }
    else if (differenceInMinutes < 60) {
        return `${differenceInMinutes} minute${differenceInMinutes > 1 ? 's' : ''} ago`;
    }
    else if (differenceInHours < 24) {
        return `${differenceInHours} hour${differenceInHours > 1 ? 's' : ''} ago`;
    }
    else {
        const day = ts.getDate().toString().padStart(2, '0');
        const month = (ts.getMonth() + 1).toString().padStart(2, '0');
        const year = ts.getFullYear().toString().slice(-2);
        return `${day}/${month}/${year}`;
    }
}

function stringToColor(string) {
    const hash = [...string].reduce((acc, char) => {
        return char.charCodeAt(0) + ((acc << 5) - acc);
    }, 0);

    // Generate a color in hex format
    const color = `#${((1 << 24) + (hash & 0xFFFFFF)).toString(16).slice(1)}`;

    return color;
}

function getTextColorForBackground(string) {
    const backgroundColor = stringToColor(string);

    // Extract the RGB values
    const [r, g, b] = [
        parseInt(backgroundColor.slice(1, 3), 16),
        parseInt(backgroundColor.slice(3, 5), 16),
        parseInt(backgroundColor.slice(5, 7), 16)
    ];

    // Calculate luminance
    const luminance = 0.299 * r + 0.587 * g + 0.114 * b;

    // Return white for dark backgrounds and black for light backgrounds
    return luminance > 186 ? '#000000' : '#FFFFFF';
}

export default function NotificationListItem(props) {
    const { notification, index, handleClick, user } = props
    const navigate = useNavigate();
    const [notificationHover, setNotificationHover] = useState(false)
    const [timeSince, setTimeSince] = useState(parseTimestamp(notification?.timestamp))
    useEffect(() => {
        const intervalId = setInterval(() => {
            setTimeSince(parseTimestamp(notification?.timestamp))
        }, 10000)
        return () => clearInterval(intervalId)
    }, [notification?.timestamp])

    const handleNotificationClick = () => {
        if (notification?.content?.navigation) {
          if (notification?.content?.edlname) {
            navigate(`${notification.content.navigation}?edlname=${encodeURIComponent(notification.content.edlname)}`);
          } else {
            navigate(notification.content.navigation);
          }
        }
      
        if (notification?.status?.[user.sub] == 1 || notification?.status?.[user.sub] == undefined ) {
          handleClick(index);
        }
      };

    return (
        <Box
            display='flex'
            my='5px'
            pt='5px'
            pb='10px'
            width='100%'
            onMouseEnter={() => setNotificationHover(true)}
            onMouseLeave={() => setNotificationHover(false)}
            sx={{
                backgroundColor: notificationHover ? 'rgba(255, 255, 255, 0.05)' : 'inherit',
                borderRadius: '7px',
                cursor: (notification?.status ?? 1) > 0 ? 'pointer' : 'default'
            }}
            onClick={handleNotificationClick}
        >
            <Box
                mr='5px'
                mt='-5px'
                mb='-10px'
                sx={{
                    width: '5px',
                    backgroundColor: stringToColor(notification?.destination?.text ?? ''),
                }}
            />
            <Box
                display='flex'
                flexDirection='column'
                width='calc(100% - 10px)'
            >
                <Box
                    display='flex'
                    flexDirection='row'
                    width='100%'
                >
                    <Box
                        display='flex'
                        flexDirection='column'
                        width='100%'
                    >
                        <Box
                            display='flex'
                            width='100%'
                        >
                            <Box
                                alignItems='center'

                                sx={{
                                    overflowWrap: 'anywhere',
                                    ...notification?.content?.title
                                    ?
                                    { width: '100%' }
                                    :
                                    {}
                                }}
                            >
                                <Typography
                                    fontSize='14px'
                                >
                                    {notification?.content?.title ?? ''}
                                </Typography>
                            </Box>
                            <Box
                                px='5px'
                            >
                                <Chip
                                    variant='filled'
                                    sx={{
                                        height: 'auto',
                                        minWidth: 'auto',
                                        backgroundColor: stringToColor(notification?.source?.text ?? ''),
                                        color: getTextColorForBackground(notification?.source?.text ?? ''),
                                        fontSize: '10px',
                                        '& .MuiChip-label': {
                                            padding: '2px 10px'
                                        }
                                    }}
                                    label={notification?.source?.text ?? ''}
                                />
                            </Box>
                            <Box
                                marginTop={1}
                                minWidth='10px'
                                maxWidth='10px'
                                sx={{
                                    ...notification?.content?.title
                                    ?
                                    {}
                                    :
                                    { marginLeft: 'auto' }
                                }}
                            >
                                {(notification?.status?.[user?.sub] ?? 1) > 0 &&
                                <Box
                                    width='5px'
                                    height='5px'
                                    borderRadius='5px'
                                    sx={{
                                        backgroundColor: 'rgb(123, 234, 41)'
                                    }}

                                />
                                }
                            </Box>
                        </Box>
                        <Box>
                            <Typography
                                fontSize={'10px'}
                                color='rgb(125, 125, 125)'
                            >
                                {timeSince}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
                {notification?.content?.text &&
                <Box
                    sx={{
                        backgroundColor: 'rgb(75, 75, 75)',
                        borderRadius: '5px',
                        mr: '10px',
                        p: '5px',
                    }}
                >
                    <Typography
                        fontSize='12px'
                        color='rgb(200, 200, 200)'
                    >
                        {notification?.content?.text ?? ''}
                    </Typography>
                </Box>
                }
            </Box>
        </Box>
    )
}